import { render, staticRenderFns } from "./MassEditTimeLimitsSettings.vue?vue&type=template&id=3c0646e1&scoped=true"
import script from "./MassEditTimeLimitsSettings.vue?vue&type=script&lang=ts"
export * from "./MassEditTimeLimitsSettings.vue?vue&type=script&lang=ts"
import style0 from "./MassEditTimeLimitsSettings.vue?vue&type=style&index=0&id=3c0646e1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0646e1",
  null
  
)

export default component.exports